module.exports = __webpack_public_path__ + "img/dc-agro.5efef5fe.svg";